import { css } from "@emotion/react";
import React from "react";
import { TTargetList } from ".";
import trelloColors from "../../styles/trello-colors";
import ConditionalRender from "../shared/components/conditional-renderer";

type TProps = {
  doneCount: number;
  wipCount: number;
  cardsCount: number;
};

const BoardTargetsSummary = (props: TProps) => {
  // const hasDone = props.doneCount as number > 0;
  const hasWIP = (props.wipCount as number) > 0;
  const allDone = props.doneCount == props.cardsCount && props.cardsCount > 0;
  const boardsWithTargetSummary = `cards done: ${props.doneCount}\ncards in progress: ${props.wipCount}\ncards total: ${props.cardsCount}`;

  return (
    <div
      title={boardsWithTargetSummary}
      css={[styles.boardHeading, styles.cursorInfo]}
    >
      <span css={[allDone && styles.target("done")]}>{props.doneCount}</span>
      <span css={[allDone && styles.target("done")]}>&nbsp;/&nbsp;</span>
      <span css={[allDone && styles.target("done")]}>{props.cardsCount}</span>
      <ConditionalRender
        condition1={hasWIP}
        renderIf1True={
          <React.Fragment>
            <span css={[styles.target("none")]}>&nbsp;(</span>
            <span css={[styles.target("wip")]}>{props.wipCount}</span>
            <span css={[styles.target("none")]}>)</span>
          </React.Fragment>
        }
      />
    </div>
  );
};

export default BoardTargetsSummary;

const styles = {
  cursorInfo: css`
    cursor: help;
  `,
  target: (list: TTargetList) => css`
    color: ${list == "done"
      ? trelloColors["green-600"]
      : list == "wip"
      ? trelloColors["orange-600"]
      : "inherit"};
  `,
  boardHeading: css`
    font-weight: 600;
    z-index: 1;
    display: flex;
  `,
};
